export default "__VITE_ASSET__Bjb1IRKD__"